import { APIEndpoints, APIPaths } from "../../../AWS/APIEndpoints";
import { clientTypes } from "shared/dist/utils/clientTypes";
import { userPreferenceCommunicationTypes } from "../../../../Utils/user";
import { fetchAuthenticatedUser } from "./loginActions";
import { initializeAPIOptions, postAPI } from "../../../../Utils/API";

const updatePreferencesAPI = (payload) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.USER.name;
    const apiPath = APIPaths.USER_PREFERENCES;
    const apiOptions = initializeAPIOptions(token, { userPreferences: payload });
    return await postAPI(apiName, apiPath, apiOptions);
};

const generateEmailPreferencesPayload = (emailPreferences) => {
    const preferences = Object.entries(emailPreferences).map(([key, value]) => ({
        preferenceType: key,
        communicationType: userPreferenceCommunicationTypes.EMAIL,
        source: clientTypes.PUBLISHER_DAPP,
        status: value ? "ENABLED" : "DISABLED",
        optOutReason: !value ? "" : undefined,
    }));
    return preferences;
};

export const updateEmailPreferences = (emailPreferences) => (dispatch) => {
    const payload = generateEmailPreferencesPayload(emailPreferences);
    dispatch(updatePreferencesAPI(payload));
};
